import React from 'react';

/**
 * Error boundary for the student lesson card. If anything inside throws,
 * render an inline error message instead of letting React unmount the
 * whole tree (which causes the dark/blue blank-screen symptom).
 */
export default class LessonCardErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('[LessonCard crash]', error, info);
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="bg-[#2D3748] border border-red-500/40 rounded-lg p-6 m-6">
                    <div className="text-red-400 font-semibold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                        Oeps — er ging iets mis bij het laden van deze leskaart
                    </div>
                    <div className="text-gray-300 text-sm mb-4">
                        {String(this.state.error?.message || this.state.error || 'Onbekende fout')}
                    </div>
                    <button
                        onClick={this.handleReset}
                        className="px-4 py-2 bg-[#D4A537] text-[#1A202C] rounded font-medium hover:bg-[#E5B84A]"
                    >
                        Opnieuw proberen
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
